import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RequireAuth = () => {
    const { auth, authChecked } = useAuth();
    const location = useLocation();

    // If auth status hasn't been verified yet (e.g. cold load in new tab), wait
    if (!authChecked && !auth?.role) {
        return null;
    }

    const isAdminRoute = location.pathname.startsWith("/admin");
    const isStaff = auth?.role === "ADMIN" || auth?.role === "EMPLOYEE";

    // Admin-specific routes require staff role (ADMIN or EMPLOYEE)
    if (isAdminRoute && !isStaff) {
        return <Navigate to="/admin" state={{ from: location }} replace />;
    }

    // Authenticated users may access protected routes (e.g. /dashboard shows
    // CustomerDashboard for USER, Admin/Employee dashboards for staff — see AdminPages/Dashboard.js).
    return auth?.role ? (
      <Outlet />
    ) : (
      <Navigate to={isAdminRoute ? "/admin" : "/"} state={{ from: location }} replace />
    );
}

export default RequireAuth;
